import { Collection, CollectionProduct } from 'types/collection'
import { isMatchingVariantForOptions } from './isMatchingVariantForOptions'
import { FilterOption } from 'types/filters'

type CollectionProductsListWithMatchingVariantsArgs = {
  product: CollectionProduct
  productsWithMatchingVariants: CollectionProduct[]
  filterOptions: FilterOption[]
  variantExist: boolean
}

function getCollectionProductsListWithMatchingVariants({
  product,
  productsWithMatchingVariants,
  filterOptions,
  variantExist
}: CollectionProductsListWithMatchingVariantsArgs) {
  const atLeastOneMatch = (product.variants || []).some(variant => {
    return (
      (variant.inventory_quantity || variant.pre_order_inventory_quantity) &&
      isMatchingVariantForOptions({
        productOptions: product.options,
        variant,
        filterOptions
      })
    )
  })

  return atLeastOneMatch ||
    !variantExist ||
    /Belts|Socks/.test(product.product_type)
    ? [...productsWithMatchingVariants, product]
    : productsWithMatchingVariants
}

type CollectionProductData = {
  collections: Collection[]
  filterOptions: FilterOption[]
  variantExist: boolean
}

export default function getCollectionProductData({
  collections,
  filterOptions,
  variantExist
}: CollectionProductData) {
  const collectionsWithFilteredProducts: Collection[] = []
  const totalResults = collections.reduce((total, collection) => {
    const collectionProducts = collection.items.reduce(
      (
        productsWithMatchingVariants: CollectionProduct[],
        product: CollectionProduct
      ) =>
        getCollectionProductsListWithMatchingVariants({
          product,
          productsWithMatchingVariants,
          filterOptions,
          variantExist
        }),
      []
    )
    if (collectionProducts.length > 0) {
      collectionsWithFilteredProducts.push({
        ...collection,
        items: collectionProducts
      })
      return total + collectionProducts.length
    }
    return total
  }, 0)
  return { collectionsWithFilteredProducts, totalResults }
}
